<template>
  <div class="HRModuleSection col-xs-12 col-sm-10 col-centered">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'hrmodule-section',
};
</script>

<style scoped>
.HRModuleSection {
  text-align: center;
}
</style>
